// UCAT's 25%-extra-time mode. This is the one place the 1.25 multiplier
// lives — every caller that needs an extra-time-adjusted duration goes
// through getExamTimerSeconds below (or formatUcatExtraTimeLabel, which
// imports the same constant) rather than hardcoding its own copy.
export const UCAT_EXTRA_TIME_MULTIPLIER = 1.25;

/**
 * Converts a base duration in minutes into the number of seconds an exam
 * timer should actually run for, applying the extra-time multiplier when
 * mode is 'timed_extra'. Rounds to whole seconds (not minutes) so a
 * fractional result like 22 * 1.25 = 27.5 minutes doesn't get truncated
 * before the multiplier is applied.
 */
export function getExamTimerSeconds(minutes, mode) {
  const base = Number(minutes) || 0;
  const multiplier = mode === 'timed_extra' ? UCAT_EXTRA_TIME_MULTIPLIER : 1;
  return Math.round(base * multiplier * 60);
}

/**
 * True for any mode that runs a clock at all — 'timed' and UCAT's
 * 'timed_extra'. Use this for "is this sitting timed" branches (should a
 * countdown run, should the <5:00 warning be armed, should Next auto-advance)
 * as opposed to a `mode === 'timed'` check, which only some call sites
 * genuinely mean (e.g. ones picking which duration to display, where
 * 'timed_extra' needs its own distinct branch instead).
 */
export function isTimedMode(mode) {
  return mode === 'timed' || mode === 'timed_extra';
}

/** Keep UCAT `timed_extra` on resume; anything else is timed or untimed. */
export function resolveSittingAttemptMode(mode) {
  if (mode === 'timed_extra') return 'timed_extra';
  if (mode === 'timed') return 'timed';
  return 'untimed';
}
